import"./../CalloutFont/CalloutFont.css.ts.vanilla.css";import"./PriceFont.css.ts.vanilla.css";var t="PriceFont_fontStyle__w0cm2q1";export{t as fontStyle};
//# sourceMappingURL=PriceFont.css.vanilla.js.map
